'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/manage-catalogs-empty.hbs');

var ManageCatalogsEmptyView = ItemView.extend({
    template: template,

    tagName: 'li',
});

module.exports = ManageCatalogsEmptyView;